/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  IconButton,
  LinearProgress,
  Paper,
  TextField,
  Tooltip,
  Typography,
  Autocomplete,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormLabel,
  FormControl,
  Fab
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { useEffect, useState } from "react";
import Message from "../../../utils/Message";
import {
  getPersonasFisicas,
} from "../../../services/PersonaFisicaService";
import { useNavigate } from "react-router-dom";
import "../../../core/styles/busqueda.css";
import { Add, Clear, DoNotDisturbOn, Edit } from "@mui/icons-material";
import { getTiposDocumento } from "../../../services/ParametrosService";
import { getPersonasJuridicas } from "../../../services/PersonaJuridicaService";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const initialSearchData = {
  numeroDocumento: "",
  fecha_nacimiento: "",
  fecha_fallecimiento: "",
  razon_social: "",
  email: "",
  cuit: "",
  estadoCivil: "",
  profesiones: "",
  telefono: "",
  domicilio: "",
  estado_civil: "",
  fecha_actualizacion: "",
  argentino: "Si",
  apellido: "",
  nombre: "",
  idTipoDocumento: "",
};

const nameItemsText = "Personas Jurídicas";
//
// #############################################################################  
//
const PersonaJuridicaTable = () => {
  const navigate = useNavigate();
  const [searchData, setSearchData] = useState(initialSearchData);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [personas, setPersonas] = useState([]);
  const [PersonaSelected, setPersonaSelected] = useState([]);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [_idPersona, set_idPersona] = useState(null);
  const [documentos, setDocumentos] = useState([]);
  const [valueAutoCompleteTipoDocumento, setValueAutoCompleteTipoDocumento]
    = useState
      ({
        id: "",
        descripcion: ""
      })
  const [
    inputValueAutoCompleteTipoDocumento,
    setInputValueAutoCompleteTipoDocumento]
    = useState("");
  const [selectedDate, setSelectedDate] = useState(null);

  const tableColumns = [
    {
      name: "id",
      label: "ID",
      options: {
        display: "excluded",
      },
    },
    {
      name: "cuit",
      label: "CUIT",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        })
      },

    },
    {
      name: "razon_social",
      label: "Razón Social",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center',
            fontSize: '12px'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRender: (value) => {
          // pasa el valor a mayusculas
          return value.toUpperCase();
        }
      },
    },

    {
      name: "email",
      label: "Correo Electrónico",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        })
      },
    },
    {
      name: "numero_inscripcion",
      label: "N° de Inscripción",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        })
      },
    },
    {
      name: "fecha_creacion",
      label: "Fecha de Creación",
      options: {
        filter: false,
        sort: false,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => {
          let _val = ""
          let _fecha = new Date(personas[dataIndex].fecha_creacion)
          let _dia = _fecha.getDate().toString().padStart(2, '0')
          let _mes = (_fecha.getMonth() + 1).toString().padStart(2, '0')
          let _anio = _fecha.getFullYear()
          let _hora = _fecha.getHours().toString().padStart(2, '0')
          let _minutos = _fecha.getMinutes().toString().padStart(2, '0')
          let _segundos = _fecha.getSeconds().toString().padStart(2, '0')
          _val = _dia + '-' + _mes + '-' + _anio + ' ' + _hora + ':' + _minutos + ':' + _segundos

          return _val;
        },
      },
    },

    {
      name: "actions",
      label: "Acciones",
      options: {
        filter: false,
        sort: false,
        empty: true,
        setCellProps: () => ({
          style: {
            textAlign: 'center'
          }
        }),
        setCellHeaderProps: () => ({
          style: {
            textAlign: 'center',
          },
        }),
        customBodyRenderLite: (dataIndex, rowIndex) => (
          <>

            <Tooltip title="Ver Persona">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() => obtienePersona(dataIndex, "view")}
              >
                <RemoveRedEyeOutlinedIcon />
              </IconButton>

            </Tooltip>
            {/* <Tooltip title="Editar Persona">
                <IconButton
                  size="small"
                  aria-label="update"
                  onClick={() => editaPersona(dataIndex, "edit")}
                >
                  <Edit />
                </IconButton>
              </Tooltip> */}
          </>
        ),
      },
    },
  ];

  const tableOptions = {
    download: false,
    filter: false,
    print: false,
    search: false,
    viewColumns: false,
    elevation: 5,
    // Controls the visibility of the Select Toolbar
    selectToolbarPlacement: "none",
    // Show/hide the select all/deselect all checkbox header for selectable rows
    selectableRowsHeader: false,
    // Hides the checkboxes that appear when selectableRows is set to "multiple" or "single"
    selectableRowsHideCheckboxes: false,
    // Indicates if rows can be selected. Options are "multiple", "single", "none"
    selectableRows: "none",

    // Callback function that triggers when row(s) are selected/deselected
    onRowSelectionChange: (
      currentRowsSelected,
      allRowsSelected,
      rowsSelected
    ) => {
      seleccionarPersona(currentRowsSelected, allRowsSelected, rowsSelected);
    },
    // User provided array of numbers (dataIndexes) which indicates the selected rows
    rowsSelected: PersonaSelected,

    rowsPerPageOptions: [10, 20, 30],
    serverSide: true,
    count: totalRowsCount,
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: (numberOfRows) => {
      setRowsPerPage(numberOfRows);
    },
    onChangePage: (currentPage) => {
      setCurrentPage(currentPage);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
      },
      pagination: {
        next: "Próxima",
        previous: "Previa",
        rowsPerPage: "Filas:",
        displayRows: "de",
      },
    },
  };

  //
  // ################################################################################
  //
  const seleccionarPersona = (currentRowsSelected, allRowsSelected, rowsSelected
  ) => {
    setPersonaSelected(rowsSelected);
  };

  //
  // ################################################################################
  // cuando cambia la pagina actual o la cantidad de filas por pagina
  //
  useEffect(() => {
    load();
    loadTiposDocumento();
  }, [currentPage, rowsPerPage]);

  //
  // ################################################################################
  //
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData(prevState => ({
      ...prevState,
      [name]: value,
    }));
    console.log('searchData updated:', { ...searchData, [name]: value });
  };



  const handleRadioChange = (e) => {
    const { name, value } = e.target;
    setSearchData(prevState => ({
      ...prevState,
      [name]: value,
    }));
    console.log('Radio changed:', { ...searchData, [name]: value });
  };



  //
  // ################################################################################
  //
  const handleChangeFechaCreacionDesde = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionDesde: fecha,
    });
  };

  //
  // ################################################################################
  //
  const handleChangeFechaCreacionHasta = (fecha) => {
    setSearchData({
      ...searchData,
      fechaCreacionHasta: fecha,
    });
  };

  //
  // ################################################################################
  //
  const handleDateChange = (fecha) => {
    setSearchData({
      ...searchData,
      fecha_contrato_social: fecha,
    });
  };

  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setIsDoingSomething(true);
    setSearchData(initialSearchData);
    setValueAutoCompleteTipoDocumento({
      id: "",
      descripcion: ""
    });
    setTotalRowsCount(0);
    setPersonas([]);
    setPersonaSelected([]);
    setIsDoingSomething(false);
  };

  const handleNuevaPersona = () => {
    navigate("/personas/persona-fisica/nuevo");
  }

  //
  // ################################################################################
  //
  const handleBuscar = () => {
    load();
  };

  //
  // ################################################################################
  // Funcion de busqueda .. 
  const load = async () => {

    let _params = {
      id: searchData.id,
      // argentino: searchData.argentino,
      razon_social: searchData.razon_social,
      email: searchData.email,
      cuit: searchData.cuit,
      numero_inscripcion: searchData.numero_inscripcion,
      tipo_societario: searchData.tipo_societario,
      fecha_contrato_social: searchData.fecha_contrato_social,
      fecha_actualizacion: searchData.fecha_actualizacion,
      estadoActual: searchData.estadoActual,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,

    };


    setIsDoingSomething(true);
    const response = await getPersonasJuridicas(_params);
    setIsDoingSomething(false);
    console.log('response: ', response)
    if (response.ok) {
      let _personas = response.data.data;
      setTotalRowsCount(response.data.count);
      setPersonas(_personas);

    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };

  //
  // ###############################################################################
  //

  const loadTiposDocumento = async () => {
    const response = await getTiposDocumento();
    if (response.ok) {
      let _response = response.data[0].data;
      _response.forEach((item) => {
        item.descripcion = item.descripcion.toUpperCase();
      });

      setDocumentos(_response);

    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }


  //
  // ###############################################################################
  //
  const obtienePersona = (dataIndex, parAction) => {
    let _id = personas[dataIndex].id;
    // let _url = "/personas/persona-fisica/" + _id + "/" + parAction;
    // window.open(_url, "_blank");
    navigate("/personas/persona-juridica/" + _id + "/" + parAction);

  };

  //
  // ###############################################################################
  //
  const nuevaPersona = () => {
    navigate("/personas/persona-juridica/new");

  };

  //
  // ################################################################################
  //
  const editaPersona = (dataIndex, parAction) => {
    let _id = personas[dataIndex].id;
    navigate("/personas/persona-juridica/" + _id + "/" + parAction);

  }
  //
  // ################################################################################
  // habilito para que al precionar la tecla enter se ejecute la busqueda

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      console.log('ejecutando keydown');

      handleBuscar();
    }
  };


  return (
    <>

      <Paper elevation={0} sx={{ p: 1, m: 1, maxWidth: "100%" }}>

        <Paper elevation={3} sx={{ mb: 1 }}>
          <Box p={2}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="center" alignItems="center" sx={{ mb: 2, mt: 2 }}>
                  <Typography variant="h4" display="block" gutterBottom>
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="cuit"
                  label="Cuit"
                  variant="outlined"
                  size="small"
                  name="cuit"
                  value={searchData.cuit}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>


              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="razon_social"
                  label="Razón Social"
                  variant="outlined"
                  size="small"
                  name="razon_social"
                  value={searchData.razon_social}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={3}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="email"
                  label="Correo Electrónico"
                  variant="outlined"
                  size="small"
                  name="email"
                  value={searchData.email}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}> </Grid>
              <Grid item xs={12} md={6} lg={2}> </Grid>
              <Grid item xs={12} md={6} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="numero_inscripcion"
                  label="Número de Inscripción"
                  variant="outlined"
                  size="small"
                  name="numero_inscripcion"
                  value={searchData.numero_inscripcion}
                  onChange={handleChange}
                  onKeyDown={handleKeyDown}
                />
              </Grid>

              <Grid item xs={12} md={6} lg={2}>

                <DatePicker
                  sx={{
                    width: "100%",
                    mb: 1,
                    '& .MuiInputLabel-root': {
                      transform: 'translate(14px, 9px) scale(1)',
                    },
                    '& .MuiInputBase-root': {
                      paddingRight: '10px',
                    },
                    '& .MuiInputLabel-shrink': {
                      transform: 'translate(14px, -8px) scale(0.75)',
                    },
                  }}
                  size="small"
                  label="Fecha Contrato Social"
                  maxDate={new Date()}
                  minDate={new Date('1900-01-01')}
                  value={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                    handleDateChange(date);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                    />
                  )}
                />

              </Grid>




              {/* ToggleButtonGroup para cambio de tipo de busqueda */}
              <Grid item xs={12} md={12} lg={12}></Grid>
              <Grid
                xs={12}
                md={12}
                lg={8}
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  alignItems: "center",
                }}
              >
                <Box sx={{ display: "flex", gap: 1 }}>


                  <Tooltip title="Limpiar filtros">
                    <Button
                      fullWidth
                      sx={{ mt: 2 }}
                      variant="outlined"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>

                  <Tooltip title="Buscar">
                    <Button
                      fullWidth
                      sx={{ mt: 2 }}
                      variant="contained"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>

                </Box>
              </Grid>

            </Grid>

          </Box>
        </Paper >

        {isDoingSomething && <LinearProgress />}

        <MUIDataTable
          title={"Listado de Personas Físicas"}
          data={personas}
          columns={tableColumns}
          options={tableOptions}
        />

      </Paper >


      {/* >>>> Messages */}

      {
        showMessage && (
          <Message
            showMessage={showMessage}
            setShowMessage={setShowMessage}
            message={message}
          />
        )
      }
    </>
  );
};

export default PersonaJuridicaTable;
